<template>
    <!--@formatter:off-->
    <div class="agreement_item">
        <div @click.prevent="onClickCheck">
            <CommonCheckbox v-model="isChecked" class="checkbox" :style="{
                height:'24px'
            }" >
                <template #labelText>
                    <div :style="{
                        width: 'calc(100% - 98px)',
                        fontSize:'15px',
                        fontWeight: '400',
                        verticalAlign:'bottom',
                        lineHeight:'150%',
                        color:'#1a1a1a',
                        textOverflow: 'ellipsis',
                        marginLeft: '4px',
                          display: '-webkit-box',
                          webkitBoxOrient: 'vertical',
                          webkitLineClamp: '2',
                          overflow: 'hidden',
                          wordBreak: 'break-all',
                    }">
                        {{agreement.question}}
                    </div>
                </template>
            </CommonCheckbox>
        </div>
        <button @click="showDesc" :style="{
            position: 'absolute',top:'4px',right:'0'
        }">
            <template v-if="!isShowDesc">
                <span :style="{
                    fontSize:'14px',
                    color:'#999'
                }">상세보기<IconChevronDown :color="'#999999'" :style="{width:'12px', height:'12px'}"/>
                </span>
            </template>
            <template v-else>
                <span :style="{
                    fontSize:'14px',
                    color:'#999'
                }">상세보기<IconChevronDown :color="'#999999'" :style="{width:'12px', height:'12px',transform:'rotate(180deg)'}"/>
                </span>
            </template>
        </button>
        <div v-if="isShowDesc" :style="{
            overflow:'hidden',
            marginTop: '6px',
            width:'100%',
            height: '100px',
            border: '1px solid #ccc',
            borderRadius: '5px',
                boxSizing:'border-box'
        }">
            <textarea
                :style="{
                width:'100%',
                height: '100%',
                lineHeight: '150%',
                fontSize: '12px',
                padding:'13px 16px',
                boxSizing:'border-box',
                border:'none',
                color:'#666',
            }"
                :value="agreement.questionDesc" readonly></textarea>
        </div>
    </div>
    <!--@formatter:on-->
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import {ENROLMENT_RESPONSE_NAMESPACE} from '@/common/store';
import CommonCheckbox from '@iamteacherpc/assets/common/component/CommonCheckbox.vue';
import IconRequired from '@iamteacherpc/assets/common/icon/IconRequired.vue';
import {CHECK_AGREEMENTS, UNCHECK_AGREEMENT} from '@common/store/modules/enrolment/response';
import IconChevronDown from '@iamteacherpc/assets/common/icon/IconChevronDown.vue';
import {SURVEY_ANSWER_STATE_TYPE} from '@common/consts/response';

const {mapState, mapGetters, mapActions} = createNamespacedHelpers(ENROLMENT_RESPONSE_NAMESPACE);

export default {
    name: 'EnrolmentResponseAgreement',
    components: {IconChevronDown, IconRequired, CommonCheckbox},
    props: {
        agreement: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isShowDesc: false,
        };
    },
    computed: {
        ...mapState({
            checkedAgreementsNos: state => state.options.checkedAgreementsNos,
            answerStateType: state => state.survey.answerStateType,
            isPreview: state => state.options.isPreview,
        }),

        isChecked() {
            return this.checkedAgreementsNos.includes(this.agreement.questionNo);
        },
    },
    methods: {
        ...mapActions({
            checkAgreements: CHECK_AGREEMENTS,
            uncheckAgreement: UNCHECK_AGREEMENT,
        }),

        showDesc() {
            this.isShowDesc = !this.isShowDesc;
        },
        onClickCheck() {
            if (this.isPreview) {
                if (!this.isChecked) {
                    this.checkAgreements({questionNos: [this.agreement.questionNo]});
                } else {
                    this.uncheckAgreement({questionNo: this.agreement.questionNo});
                }
                return;
            }
            if (!this.isChecked) {
                this.checkAgreements({questionNos: [this.agreement.questionNo]});
            } else {
                if (this.answerStateType === SURVEY_ANSWER_STATE_TYPE.ANSWER) {
                    this.$showAlert({
                        desc: '강좌 신청 완료 후에는 개인정보 수집 및 이용 동의를 변경할 수 없습니다.',
                        okText: this.$t('common_confirm'),
                        ok: async () => {
                            //...
                        },
                    });
                    return;
                }
                this.uncheckAgreement({questionNo: this.agreement.questionNo});
            }
        },
    },
};
</script>

<style scoped>
.checkbox::v-deep label {
    display: inline-flex;
    width: 100%;
}

.agreement_item {
    margin-top: 6px;
    position: relative
}

.agreement_item:first-child {
    margin-top: 0;
}

textarea::-webkit-scrollbar {
    width: 10px;
}

textarea::-webkit-scrollbar-thumb {
    background: #b4b4b4;
    border-radius: 7px;
    border: 3px solid white;
}
</style>
